<template>
  <el-dialog
    :visible.sync="showDialog"
    :append-to-body="true"
    width="375px"
    custom-class="dialog-positive"
    :title="$t('upgrade_page_layout_dialog_positive_481')"
    @close="$emit('change', false)"
  >
    <div class="intro-positive-title">
      <img src="~@/assets/image/icons/light.png" alt="">{{$t('upgrade_page_layout_dialog_positive_482')}}</div>
    <div class="intro-positive-content">
      <div style="font-weight: 500;">{{$t('upgrade_page_layout_dialog_positive_483')}}</div>
      <ul>
        <li>
          <p>{{$t('upgrade_page_layout_dialog_positive_484')}}</p>
          <p><span>{{$t('upgrade_page_layout_dialog_positive_485')}}</span></p>
        </li>
        <li>
          <p>{{$t('upgrade_page_layout_dialog_positive_486')}}</p>
          <p><span>{{$t('upgrade_page_layout_dialog_positive_487')}}</span></p>
        </li>
      </ul>
      <div class="split"></div>
      <div>{{$t('upgrade_page_layout_dialog_positive_488')}}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showDialog: false,
    }
  },
  watch: {
    show(show) {
      this.showDialog = show
    },
  }
}
</script>

<style lang="scss">
  .dialog-positive {
    border-radius: 15px;
    overflow: hidden;
    .el-dialog__header {
      padding: 18px 20px 17px;
      border-bottom: 1px solid $color-split;
      color: $color-gray-1;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .el-dialog__body {
      padding: 20px;
      min-height: 157px;
    }
  }
</style>

<style lang="scss" scoped>
  .intro-positive {
    &-title {
      overflow: hidden;
      line-height: 24px;
      color: $color-gray-1;
      font-size: 14px;
      font-weight: 500;
      img {
        width: 24px;
        height: 24px;
        float: left;
        margin-right: 11px;
      }
    }
    &-content {
      margin-top: 20px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      text-align: left;
      ul {
        li {
          position: relative;
          padding: 16px 0 0 16px;
          &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            top: 16px;
            width: 16px;
            height: 20px;
            line-height: 20px;
            color: $color-gray-1;
          }
          &:nth-child(1)::after {
            content: '1.'
          }
          &:nth-child(2)::after {
            content: '2.'
          }
        }
        p {
          & + p {
            margin-top: 8px;
          }
          span {
            color: $color-orange;
            opacity: 0.9;
          }
        }
      }
      .split {
        width: 100%;
        height: 1PX;
        background: $color-button;
        margin: 16px 0;
      }
    }
  }
</style>
